import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPaginationState {
  loading: boolean;
  error: string;
  currentPage: number;
  pageLimit: number;
}

const initialState: IPaginationState = {
  loading: false,
  error: "",
  currentPage: 1, // Using 1-based indexing for Nakman
  pageLimit: 10,
};

const paginationSlice = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    setPageLimit: (state, action: PayloadAction<number>) => {
      state.pageLimit = action.payload;
      state.currentPage = 1; // Reset to first page when limit changes
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    resetPagination: (state) => {
      state.currentPage = initialState.currentPage;
      state.pageLimit = initialState.pageLimit;
    },
  },
});

export const { setPageLimit, setCurrentPage, resetPagination } = paginationSlice.actions;
export default paginationSlice.reducer;
